import {FC} from 'react'

const Error404: FC = () => {
  return (
    <>
      <h1 className='fw-bolder fs-4x text-gray-100 mb-10'>Страница не найдена</h1>

      <div className='fw-bold fs-3 text-gray-400 mb-15'>
        Запрошенная страница не найдена!
      </div>
    </>
  )
}

export {Error404}
